import ShaftCondition from '@/components/shafts/condition/condition.vue';
import ShaftDashboard from '@/components/shafts/dashboard/dashboard.vue';
import ShaftDefinition from '@/components/shafts/definition/definition.vue';
import ShaftElementForm from '@/components/shafts/definition/element_form.vue';
import ShaftForm from '@/components/shafts/operations/shaft_form.vue';
import ShaftGroup from '@/components/shafts/definition/shaft_group.vue';
import ShaftInspectionDetails from '@/components/shafts/inspections/inspection_details.vue';
import ShaftInspections from '@/components/shafts/inspections/inspections.vue';
import ShaftIssueForm from '@/components/shafts/issue_form.vue';
import ShaftJob from '@/components/shafts/maintenance/job.vue';
import ShaftJobs from '@/components/shafts/maintenance/jobs.vue';
import ShaftLayout from '@/components/shafts/shaft_layout.vue';
import ShaftScroll from '@/components/shafts/condition/shaft_scroll.vue';
import ShaftIssueHistory from '@/components/issues/issue_history.vue';

export default [
  {
    path: 'shafts/:shaftId',
    name: 'shaft',
    component: ShaftLayout,
    props: true,
    redirect: { name: 'shaftDashboard' },
    children: [
      {
        path: '',
        name: 'shaftDashboard',
        component: ShaftDashboard,
        props: true,
      },
      {
        path: 'condition',
        name: 'shaftCondition',
        component: ShaftCondition,
        props: true,
        children: [
          {
            path: ':elementType',
            name: 'shaftScroll',
            component: ShaftScroll,
            props: true,
            children: [
              {
                path: ':memberId',
                name: 'shaftScrollDetail',
                component: ShaftScroll,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: ':scope(inspections|approved_inspections)',
        name: 'shaftInspections',
        component: ShaftInspections,
        props: true,
        children: [
          {
            path: ':inspectionId',
            name: 'shaftInspection',
            component: ShaftInspectionDetails,
            props: true,
          },
        ],
      },
      {
        path: ':scope(jobs|completed_jobs)',
        name: 'shaftJobs',
        component: ShaftJobs,
        props: true,
        children: [
          {
            path: ':jobId',
            name: 'shaftJob',
            component: ShaftJob,
            props: true,
          },
        ],
      },
      {
        path: 'definition',
        name: 'shaftDefinition',
        component: ShaftDefinition,
        props: true,
        children: [
          {
            path: ':elementType',
            name: 'shaftGroup',
            component: ShaftGroup,
            props: true,
            children: [
              {
                path: ':memberId',
                name: 'shaftGroupDetail',
                component: ShaftGroup,
                props: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'shafts/:shaftId/edit',
    name: 'editShaft',
    component: ShaftForm,
    props: true,
  },
  {
    path: 'shafts/new',
    name: 'newShaft',
    component: ShaftForm,
    props: true,
  },
  {
    path: 'shafts/:shaftId/definition/:elementType/:elementGroupId/element/new',
    name: 'newShaftElementForm',
    component: ShaftElementForm,
    props: true,
  },
  {
    path: 'shafts/:shaftId/definition/:elementType/:elementGroupId/element/:elementId/edit',
    name: 'editShaftElementForm',
    component: ShaftElementForm,
    props: true,
  },
  {
    path: 'shafts/:shaftId/inspections/:inspectionId/issues/new',
    name: 'newShaftIssue',
    component: ShaftIssueForm,
    props: true,
  },
  {
    path: 'shafts/:shaftId/inspections/:inspectionId/issues/:issueId',
    name: 'shaftIssue',
    component: ShaftIssueForm,
    props: true,
  },
  {
    path: 'shafts/:shaftId/inspections/:inspectionId/issues/:issueId/history',
    name: 'shaftIssueHistory',
    component: ShaftIssueHistory,
    props: true,
  },
];
